import { render, staticRenderFns } from "./QuotaholdersSelector.vue?vue&type=template&id=5264f128&"
import script from "./QuotaholdersSelector.vue?vue&type=script&lang=js&"
export * from "./QuotaholdersSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports